export const frontend_server =
  process.env.REACT_APP_FRONTEND_URL || "https://ligaespanolaaoe2.netlify.app";
export const backend_server_v3 =
  process.env.REACT_APP_BACKEND_URL || "https://lea-be-3-b751e0637183.herokuapp.com";

//  export const frontend_server = "http://localhost:3000";
// export const frontend_server = "https://ligaespanolaaoe2.netlify.app";
// export const frontend_server = "https://glowing-space-spoon-6q67564jjfx6qw-3000.app.github.dev";
// export const backend_server_v3 = "https://lea-be-3-b751e0637183.herokuapp.com";
// export const backend_server_v3 = "http://127.0.0.1:8000";
//export const backend_server_v3 = "https://leabe3.azurewebsites.net";
// export const backend_server_v3 = "https://ubiquitous-trout-x76qp6v6v2697g-8000.app.github.dev"; 

export const links = [
  {
    id: 1,
    text: "Home",
    url: "/",
  },
  {
    id: 2,
    text: "Hall of fame",
    url: "/hall-of-fame",
  },
  {
    id: 3,
    text: "quienes somos",
    url: "/about",
  },
  {
    id: 4,
    text: "Leaderboard",
    url: "/leaderboard",
  },
];
export const divisionesT3 = [
  {
    id: 1,
    text: "1. Campeones",
    image: "campeones.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019563345293443072/groups/5019565746743336960/#structure",
  },
  {
    id: 2,
    text: "2. Mandobles",
    image: "mandobles.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019567664592478208/groups/5019567665330675757/#structure",
  },
  {
    id: 3,
    text: "3. Espadas largas",
    image: "espadas-largas.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019568919348551680/groups/5019568920153858093/#structure",
  },
  {
    id: 4,
    text: "4. Hombres de armas",
    image: "hombres-de-armas.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019570896182738944/groups/5021267705441075200/#structure",
  },
  {
    id: 5,
    text: "5. Alabarderos",
    image: "alabarderos.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019572142017765376/groups/5019572142823071785/#structure",
  },
  {
    id: 6,
    text: "6. Milicias",
    image: "milicias.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019573105499332608/groups/5021271138530066432/#structure",
  },
  {
    id: 7,
    text: "7. Piqueros",
    image: "piqueros.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019574310140534784/groups/5019574310979395629/#structure",
  },
  {
    id: 8,
    text: "8. Lanceros",
    image: "lanceros.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019575287286939648/groups/5019575288058691625/#structure",
  },
];

export const divisionesT4 = [
  {
    id: 1,
    text: "1. Campeones",
    image: "campeones.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019563345293443072/groups/5019565746743336960/#structure",
  },
  {
    id: 2,
    text: "2. Mandobles",
    image: "mandobles.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019567664592478208/groups/5019567665330675757/#structure",
  },
  {
    id: 3,
    text: "3. Espadas largas",
    image: "espadas-largas.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019568919348551680/groups/5019568920153858093/#structure",
  },
  {
    id: 4,
    text: "4. Hombres de armas",
    image: "hombres-de-armas.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019570896182738944/groups/5021267705441075200/#structure",
  },
  {
    id: 5,
    text: "5. Alabarderos",
    image: "alabarderos.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019572142017765376/groups/5019572142823071785/#structure",
  },
  {
    id: 6,
    text: "6. Milicias",
    image: "milicias.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019573105499332608/groups/5021271138530066432/#structure",
  },
  {
    id: 7,
    text: "7. Piqueros",
    image: "piqueros.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019574310140534784/groups/5019574310979395629/#structure",
  },
  {
    id: 8,
    text: "8. Lanceros",
    image: "Lanceros.png",
    link: "https://play.toornament.com/es/tournaments/5019556577757560832/stages/5019575287286939648/groups/5019575288058691625/#structure",
  },
];

export const divisionesT5 = [
  {
    id: 16,
    name: "1. Paladines",
    season: 5,
    group: 0,
    image: "",
    sequence: 2,
  },
  {
    id: 17,
    name: "2. Campeones",
    season: 5,
    group: 1,
    image: "",
    sequence: 3,
  },
  {
    id: 18,
    name: "2. Campeones",
    season: 5,
    group: 2,
    image: "",
    sequence: 3,
  },
  {
    id: 20,
    name: "3. Mandobles",
    season: 5,
    group: 2,
    image: "",
    sequence: 4,
  },
  {
    id: 19,
    name: "3. Mandobles",
    season: 5,
    group: 1,
    image: "",
    sequence: 4,
  },
  {
    id: 21,
    name: "4. Espadas Largas",
    season: 5,
    group: 1,
    image: "",
    sequence: 5,
  },
  {
    id: 22,
    name: "4. Espadas Largas",
    season: 5,
    group: 2,
    image: "",
    sequence: 5,
  },
  {
    id: 23,
    name: "5. Hombres de Armas",
    season: 5,
    group: 1,
    image: "",
    sequence: 6,
  },
  {
    id: 24,
    name: "5. Hombres de Armas",
    season: 5,
    group: 2,
    image: "",
    sequence: 7,
  },
  {
    id: 27,
    name: "6. Alabarderos",
    season: 5,
    group: 3,
    image: "",
    sequence: 8,
  },
  {
    id: 25,
    name: "6. Alabarderos",
    season: 5,
    group: 1,
    image: "",
    sequence: 8,
  },
  {
    id: 26,
    name: "6. Alabarderos",
    season: 5,
    group: 2,
    image: "",
    sequence: 9,
  },
  {
    id: 28,
    name: "6. Alabarderos",
    season: 5,
    group: 4,
    image: "",
    sequence: 9,
  },
  {
    id: 29,
    name: "7. Milicias",
    season: 5,
    group: 1,
    image: "",
    sequence: 10,
  },
  {
    id: 31,
    name: "7. Milicias",
    season: 5,
    group: 3,
    image: "",
    sequence: 10,
  },
  {
    id: 30,
    name: "7. Milicias",
    season: 5,
    group: 2,
    image: "",
    sequence: 11,
  },
  {
    id: 32,
    name: "7. Milicias",
    season: 5,
    group: 4,
    image: "",
    sequence: 11,
  },
  {
    id: 33,
    name: "8. Piqueros",
    season: 5,
    group: 1,
    image: "",
    sequence: 12,
  },
  {
    id: 35,
    name: "8. Piqueros",
    season: 5,
    group: 3,
    image: "",
    sequence: 12,
  },
  {
    id: 36,
    name: "8. Piqueros",
    season: 5,
    group: 4,
    image: "",
    sequence: 13,
  },
  {
    id: 34,
    name: "8. Piqueros",
    season: 5,
    group: 2,
    image: "",
    sequence: 13,
  },
  {
    id: 37,
    name: "9. Lanceros",
    season: 5,
    group: 1,
    image: "",
    sequence: 14,
  },
  {
    id: 38,
    name: "9. Lanceros",
    season: 5,
    group: 2,
    image: "",
    sequence: 14,
  },
];

export const seasons = [
  {
    id: 5,
    name: "Temporada 5",
    groups: [
      {
        id: 16,
        name: "1. Paladines",
        season: 5,
        group: 0,
        image: "",
        sequence: 2,
      },
      {
        id: 17,
        name: "2. Campeones",
        season: 5,
        group: 1,
        image: "",
        sequence: 3,
      },
      {
        id: 18,
        name: "2. Campeones",
        season: 5,
        group: 2,
        image: "",
        sequence: 3,
      },
      {
        id: 20,
        name: "3. Mandobles",
        season: 5,
        group: 2,
        image: "",
        sequence: 4,
      },
      {
        id: 19,
        name: "3. Mandobles",
        season: 5,
        group: 1,
        image: "",
        sequence: 4,
      },
      {
        id: 21,
        name: "4. Espadas Largas",
        season: 5,
        group: 1,
        image: "",
        sequence: 5,
      },
      {
        id: 22,
        name: "4. Espadas Largas",
        season: 5,
        group: 2,
        image: "",
        sequence: 5,
      },
      {
        id: 23,
        name: "5. Hombres de Armas",
        season: 5,
        group: 1,
        image: "",
        sequence: 6,
      },
      {
        id: 24,
        name: "5. Hombres de Armas",
        season: 5,
        group: 2,
        image: "",
        sequence: 7,
      },
      {
        id: 27,
        name: "6. Alabarderos",
        season: 5,
        group: 3,
        image: "",
        sequence: 8,
      },
      {
        id: 25,
        name: "6. Alabarderos",
        season: 5,
        group: 1,
        image: "",
        sequence: 8,
      },
      {
        id: 26,
        name: "6. Alabarderos",
        season: 5,
        group: 2,
        image: "",
        sequence: 9,
      },
      {
        id: 28,
        name: "6. Alabarderos",
        season: 5,
        group: 4,
        image: "",
        sequence: 9,
      },
      {
        id: 29,
        name: "7. Milicias",
        season: 5,
        group: 1,
        image: "",
        sequence: 10,
      },
      {
        id: 31,
        name: "7. Milicias",
        season: 5,
        group: 3,
        image: "",
        sequence: 10,
      },
      {
        id: 30,
        name: "7. Milicias",
        season: 5,
        group: 2,
        image: "",
        sequence: 11,
      },
      {
        id: 32,
        name: "7. Milicias",
        season: 5,
        group: 4,
        image: "",
        sequence: 11,
      },
      {
        id: 33,
        name: "8. Piqueros",
        season: 5,
        group: 1,
        image: "",
        sequence: 12,
      },
      {
        id: 35,
        name: "8. Piqueros",
        season: 5,
        group: 3,
        image: "",
        sequence: 12,
      },
      {
        id: 36,
        name: "8. Piqueros",
        season: 5,
        group: 4,
        image: "",
        sequence: 13,
      },
      {
        id: 34,
        name: "8. Piqueros",
        season: 5,
        group: 2,
        image: "",
        sequence: 13,
      },
      {
        id: 37,
        name: "9. Lanceros",
        season: 5,
        group: 1,
        image: "",
        sequence: 14,
      },
      {
        id: 38,
        name: "9. Lanceros",
        season: 5,
        group: 2,
        image: "",
        sequence: 14,
      },
    ],
  },
];

export const t5registerform = [
  {
    stepId: 1,
    stepName: "Perfil",
    fields: [
      {
        fieldId: "username",
        title: "* username",
        mandatory: true,
        type: "text",
      },
      {
        fieldId: "discord",
        title: "* discord user",
        mandatory: true,
        type: "text",
      },
      {
        fieldId: "email",
        title: "* email",
        mandatory: true,
        type: "text",
      },
    ],
  },
  {
    stepId: 2,
    stepName: "Origen",
    fields: [
      {
        fieldId: "country_selector",
        title: "",
        mandatory: true,
        type: "single-select",
        options: [
          "Soy residente en España",
          "Soy español desplazado",
          "Soy un invitado",
        ],
      },
    ],
  },
  {
    stepId: 3,
    stepName: "Perfil AoE2",
    fields: [
      {
        fieldId: "aoe2net_principal",
        title: "* url AoE2net cuenta principal",
        mandatory: true,
        type: "text",
      },
      {
        fieldId: "aoe2net-explanation",
        title:
          "¿Tienes alguna cuenta secundaria? Por favor ponla en conocimiento de la organización.",
        mandatory: false,
        type: "explanation",
      },
      {
        fieldId: "aoe2net-secondary-1",
        title: "url AoE2net cuenta secundaria 1",
        mandatory: false,
        type: "text",
      },
      {
        fieldId: "aoe2net-secondary-2",
        title: "url AoE2net cuenta secundaria 2",
        mandatory: false,
        type: "text",
      },
    ],
  },
  {
    stepId: 4,
    stepName: "Clan",
    fields: [
      {
        fieldId: "clan",
        title: "",
        mandatory: true,
        type: "single-select-big",
        options: [
          {
            id: -1,
            name: "<No tengo clan>",
          },
          {
            id: 12,
            name: "Age of Pandemia",
            image: "AoP.png",
          },
          {
            id: 13,
            name: "Banda Catalana",
            image: "BCT.png",
          },
          {
            id: 7,
            name: "BOBOS",
            image: "BOBOS.png",
          },

          {
            id: 5,
            name: "Chirimoyos",
            image: "Cmoyo.png",
          },
          {
            id: 9,
            name: "Clan Templario",
            image: "CT.png",
          },

          {
            id: 16,
            name: "Comando KBRA",
            image: "KBRA.png",
          },
          {
            id: 2,
            name: "Conquistadores Españoles",
            image: "CONQUIS.png",
          },
          {
            id: 15,
            name: "Gamer Legion",
            image: "GL.png",
          },
          {
            id: 6,
            name: "Gentuzas",
            image: "GZAS.png",
          },
          {
            id: 14,
            name: "Goth of the rings",
            image: "GoT.png",
          },

          {
            id: 1,
            name: "Dark Knight",
            image: "DK.png",
          },

          {
            id: 11,
            name: "Forocoches of Empires",
            image: "FoE.png",
          },
          {
            id: 8,
            name: "Indeseables",
            image: "IN.png",
          },
          {
            id: 3,
            name: "NHN",
            image: "NHN.png",
          },
          {
            id: 4,
            name: "Rank1",
            image: "R1.png",
          },

          {
            id: 10,
            name: "Trifulca de Bar",
            image: "TdBar.png",
          },
          {
            id: 17,
            name: "VPKT",
            image: "VPKT.png",
          },
          {
            id: 0,
            name: "Otro clan (especifica abajo)",
            image: "other-clan.png",
            showHideOptions: true,
          },
        ],
        affectedHideOptions: true,
      },
      {
        fieldId: "other-clan-explanation",
        title:
          "¿Tu clan no está en el listado? Escríbenos el nombre de tu clan y lo añadiremos al listado.",
        mandatory: false,
        type: "explanation",
        hide: true,
      },
      {
        fieldId: "clan_other_name",
        title: "Nombre del clan",
        mandatory: false,
        type: "text",
        hide: true,
      },
    ],
  },
  {
    stepId: 5,
    stepName: "Social",
    fields: [
      {
        fieldId: "social-explanation",
        title: "¿Tienes alguna red social? Compártela con nosotros!",
        mandatory: false,
        type: "explanation",
      },
      {
        fieldId: "twitch",
        title: "canal twitch",
        mandatory: false,
        type: "text",
      },
      {
        fieldId: "youtube",
        title: "canal youtube",
        mandatory: false,
        type: "text",
      },
      {
        fieldId: "twitter",
        title: "twitter",
        mandatory: false,
        type: "text",
      },
    ],
  },
];

export const clans = [
  {
    id: -1,
    name: "<No tengo clan>",
    image: "no-clan.png",
  },
  {
    id: 18,
    name: "Alianza Atántica AoE",
    image: "AAA.png",
  },
  {
    id: 20,
    name: "Ángeles Oscuros",
    image: "AO.png",
  },
  {
    id: 12,
    name: "Age of Pandemia",
    image: "AoP.png",
  },
  {
    id: 13,
    name: "Banda Catalana",
    image: "BCT.png",
  },
  {
    id: 7,
    name: "BOBOS",
    image: "BOBOS.png",
  },
  {
    id: 5,
    name: "Chirimoyos",
    image: "Cmoyo.png",
  },
  {
    id: 9,
    name: "Clan Templario",
    image: "CT.png",
  },
  {
    id: 16,
    name: "Comando KBRA",
    image: "KBRA.png",
  },
  {
    id: 2,
    name: "Conquistadores Españoles",
    image: "CONQUIS.png",
  },
  {
    id: 1,
    name: "Dark Knight",
    image: "DK.png",
  },
  {
    id: 22,
    name: "Emputors",
    image: "emputors.jpg",
  },
  {
    id: 11,
    name: "Forocoches of Empires",
    image: "FoE.png",
  },
  {
    id: 15,
    name: "Gamer Legion",
    image: "GL.png",
  },
  {
    id: 6,
    name: "Gentuzas",
    image: "GZAS.png",
  },
  {
    id: 8,
    name: "Indeseables",
    image: "IN.png",
  },
  {
    id: 14,
    name: "Lanceros Esteparios",
    image: "latest.png",
  },
  {
    id: 19,
    name: "Multikill",
    image: "MK.png",
  },
  {
    id: 3,
    name: "NHN",
    image: "NHN.png",
  },
  {
    id: 4,
    name: "Rank1",
    image: "R1.png",
  },
  {
    id: 10,
    name: "Trifulca de Bar",
    image: "TdBar.png",
  },
  {
    id: 21,
    name: "VITA",
    image: "vita.png",
  },
  {
    id: 17,
    name: "VPKT",
    image: "VPKT.png",
  },
  {
    id: 0,
    name: "Otro clan",
    image: "other-clan.png",
  },
];

export const comunidades = [
  { id: "andalucia", name: "Andalucía", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/andalucia.png" },
  { id: "aragon", name: "Aragón", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/aragon.png" },
  { id: "asturias", name: "Principado de Asturias", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/asturias.png" },
  { id: "baleares", name: "Islas Baleares", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/baleares.png" },
  { id: "canarias", name: "Canarias", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/canarias.png" },
  { id: "cantabria", name: "Cantabria", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/cantabria.png" },
  { id: "castilla-mancha", name: "Castilla-La Mancha", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/castilla-mancha.png" },
  { id: "castilla-leon", name: "Castilla y León", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/castilla-leon.png" },
  { id: "cataluna", name: "Cataluña", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/cataluna.png" },
  { id: "ceuta", name: "Ceuta", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/ceuta.png" },
  { id: "extremadura", name: "Extremadura", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/extremadura.png" },
  { id: "galicia", name: "Galicia", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/galicia.png" },
  { id: "madrid", name: "Comunidad de Madrid", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/madrid.png" },
  { id: "melilla", name: "Melilla", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/melilla.png" },
  { id: "murcia", name: "Región de Murcia", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/murcia.png" },
  { id: "navarra", name: "Comunidad Foral de Navarra", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/navarra.png" },
  { id: "pais-vasco", name: "País Vasco", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/pais-vasco.png" },
  { id: "rioja", name: "La Rioja", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/rioja.png" },
  { id: "valencia", name: "Comunidad Valenciana", flagUrl: "https://alexocampos.github.io/liga-espanhola-aoe2-static/flags/comunidades/valencia.png" },
];

export const draftT5 = {
  draft: {
    template: {
      mapBans: 1,
      mapPicks: 1,
      mapSnipes: 0,
      civBans: 1,
      civPicks: 5,
      civSnipes: 1,
    },
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerA",
        action: "PICK",
      },
    ],
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 8,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 9,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 13,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
};

export const eventsT5 = [
  {
    eventId: 1,
    date: "2022-08-31T00:00:00.000Z",
    eventDescs: ["Inicio J1"],
  },
  {
    eventId: 2,
    date: "2022-09-07T00:00:00.000Z",
    eventDescs: ["Inicio J2"],
  },
  {
    eventId: 3,
    date: "2022-09-14T00:00:00.000Z",
    eventDescs: ["Fin J1", "Inicio J3"],
  },
  {
    eventId: 4,
    date: "2022-09-21T00:00:00.000Z",
    eventDescs: ["Fin J2", "Inicio J4"],
  },
  {
    eventId: 5,
    date: "2022-09-28T00:00:00.000Z",
    eventDescs: ["Fin J3", "Inicio J5"],
  },
  {
    eventId: 6,
    date: "2022-10-05T00:00:00.000Z",
    eventDescs: ["Inicio J6"],
  },
  {
    eventId: 7,
    date: "2022-10-06T00:00:00.000Z",
    eventDescs: ["Fin J4"],
  },
  {
    eventId: 8,
    date: "2022-10-12T00:00:00.000Z",
    eventDescs: ["Fin J5", "Inicio J7"],
  },
  {
    eventId: 9,
    date: "2022-10-19T00:00:00.000Z",
    eventDescs: ["Fin J6", "Fin J7"],
  },
  {
    eventId: 10,
    date: "2022-10-26T00:00:00.000Z",
    eventDescs: ["Fin Ronda 1 Playoffs"],
  },
  {
    eventId: 11,
    date: "2022-11-05T00:00:00.000Z",
    eventDescs: ["Fin Ronda 2 Playoffs"],
  },
];

export const divisionsT5 = [
  {
    id: 1,
    name: "1. Paladines",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/paladines.png",
    link: "/season/5/group/16",
    playoffRelegationName: "Paladines (DESCENSO) - Campeones (ASCENSO)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/playoff_paladines_campeones.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/paladines_relegation.png",
    groups: [],
    champion: "TaToH",
    relegations: ["ReyO (playoff)", "c3mbrich (Descenso directo)"],
  },
  {
    id: 2,
    name: "2. Campeones",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/campeones.png",
    link: "",
    playoffRelegationName: "campeones (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/campeones_descenso.png",
    playoffPromotionName: "Paladines (DESCENSO) - Campeones (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/playoff_paladines_campeones.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/paladines_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/mandobles_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/17",
      },
      {
        name: "#2",
        link: "/season/5/group/18",
      },
    ],
    champion: "Bixiyo",
    promotions: [
      "Bixiyo (Ascenso directo)",
      "Duke Thomson (Ascenso directo)",
      "Gauss (Playoff)",
    ],
    relegations: [
      "FerV (Descenso directo)",
      "Yago (Expulsado)",
      "RumBa (PlayOff)",
      "Davicy (Expulsado)",
    ],
  },
  {
    id: 3,
    name: "3. Mandobles",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/mandobles.png",
    link: "",
    playoffRelegationName: "Mandobles (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/mandobles_descenso.png",
    playoffPromotionName: "Mandobles (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/mandobles_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/campeones_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/espadas-largas_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/19",
      },
      {
        name: "#2",
        link: "/season/5/group/20",
      },
    ],
    champion: "PoXoLo",
    promotions: [
      "PoXoLo (Ascenso directo)",
      "alonko (Ascenso directo)",
      "DM_The_Death (Playoff)",
      "Hilariano (Playoff)",
    ],
    relegations: [
      "Emgo Pceyam (Expulsado)",
      "Arkan (Descenso directo)",
      "DavidVJ (PlayOff)",
      "SetitO (PlayOff)",
    ],
  },
  {
    id: 4,
    name: "4. Espadas Largas",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/espadas-largas.png",
    link: "",
    playoffRelegationName: "Espadas Largas (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/espadas_largas_descenso.png",
    playoffPromotionName: "Espadas Largas (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/espadas_largas_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/mandobles_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/hombre-de-armas_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/21",
      },
      {
        name: "#2",
        link: "/season/5/group/22",
      },
    ],
    champion: "craser09",
    promotions: [
      "Takii13 (Ascenso directo)",
      "craser09 (Ascenso directo)",
      "DK_ManuRoki (PlayOff)",
      "Alchemist_28 (PlayOff)",
    ],
    relegations: [
      "NHN_PhisysImperi (Expulsado)",
      "E8 Rosich (Descenso directo)",
      "AlbertC (PlayOff)",
      "JARV (PlayOff)",
    ],
  },
  {
    id: 5,
    name: "5. Hombres de Armas",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/hombres-de-armas.png",
    link: "",
    playoffRelegationName: "Hombre de Armas (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/hombre_de_armas_descenso.png",
    playoffPromotionName: "Hombre de Armas (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/hombre_de_armas_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/espadas-largas_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/alabarderos_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/23",
      },
      {
        name: "#2",
        link: "/season/5/group/24",
      },
    ],
    champion: "DK_Murturul",
    promotions: [
      "DK_Murturul (Ascenso directo)",
      "TM_TOGAMI (Ascenso directo)",
      "Verlok (PlayOff)",
      "Xperos (PlayOff)",
    ],
    relegations: [
      "Nathan CT (Expulsado)",
      "Manudq (Descenso directo)",
      "Rioukay (PlayOff)",
      "JaGu4R (PlayOff)",
    ],
  },
  {
    id: 6,
    name: "6. Alabarderos",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/alabarderos.png",
    link: "",
    playoffRelegationName: "Alabarderos (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/alabarderos_descenso.png",
    playoffPromotionName: "Alabarderos (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/alabarderos_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/hombre-de-armas_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/milicias_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/25",
      },
      {
        name: "#2",
        link: "/season/5/group/26",
      },
      {
        name: "#3",
        link: "/season/5/group/27",
      },
      {
        name: "#4",
        link: "/season/5/group/28",
      },
    ],
    champion: "[KBRA] Dios Cuenca",
    promotions: [
      "JamS (PlayOff)",
      "Oppositepol (PlayOff)",
      "miguelmsk (PlayOff)",
      "[CONQUIS] Wayat (PlayOff)",
      "carrascorno (PlayOff)",
      "GaR_80s (PlayOff)",
    ],
    relegations: [
      "migueltrc (Expulsado)",
      "[CONQUIS] Doc182 (Expulsado)",
      "OldFather (Expulsado)",
      "zh3ll (Expulsado)",
      "independentziElRojo (PlayOff)",
      "Garson (PlayOff)",
      "[KBRA] BRUTAL (PlayOff)",
      "rudyairlines (PlayOff)",
    ],
  },
  {
    id: 7,
    name: "7. Milicias",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/milicias.png",
    link: "",
    playoffRelegationName: "Milicias (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/milicias_descenso.png",
    playoffPromotionName: "Milicias (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/milicias_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/alabarderos_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/piqueros_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/29",
      },
      {
        name: "#2",
        link: "/season/5/group/30",
      },
      {
        name: "#3",
        link: "/season/5/group/31",
      },
      {
        name: "#4",
        link: "/season/5/group/32",
      },
    ],
    champion: "El_Deputy",
    promotions: [
      "Mr_Alexio (Ascenso directo)",
      "FoE · RoberSvQ (Ascenso directo)",
      "El_Deputy (Ascenso directo)",
      "Rosendo (Ascenso directo)",
      "alvegaf (PlayOff)",
      "Rey Fer (PlayOff)",
      "hpbhi (PlayOff)",
      "Scorpio_10 (PlayOff)",
    ],
    relegations: [
      "sPonsius (Expulsado)",
      "Zetetiko (Descenso directo)",
      "DK_Enigma(Descenso directo)",
      "El Barón de la Birra (Expulsado)",
      "RobertoelBruce (PlayOff)",
      "Notarius (PlayOff)",
      "Mankeando Arqueritos (PlayOff)",
      "FedeElManco (PlayOff)",
    ],
  },
  {
    id: 8,
    name: "8. Piqueros",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/piqueros.png",
    link: "",
    playoffRelegationName: "Piqueros (descenso)",
    playoffRelegation:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/piqueros_descenso.png",
    playoffPromotionName: "Piqueros (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/piqueros_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/milicias_promotion.png",
    playoffRelegationIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/lanceros_relegation.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/33",
      },
      {
        name: "#2",
        link: "/season/5/group/34",
      },
      {
        name: "#3",
        link: "/season/5/group/35",
      },
      {
        name: "#4",
        link: "/season/5/group/36",
      },
    ],
    champion: "jlwv",
    promotions: [
      "Riguili (Ascenso directo)",
      "AOP | Madquimedes (Ascenso directo)",
      "SanRos95 (Ascenso directo)",
      "jlwv (Ascenso directo)",
      "Iluvatar (PlayOff)",
      "Joselu9710 (PlayOff)",
      "0iram (PlayOff)",
      "GzKernel (PlayOff)",
    ],
    relegations: [
      "Moniqueta(Expulsado)",
      "quitin1(Expulsado)",
      "KorKo(PlayOff)",
    ],
  },
  {
    id: 9,
    name: "9. Lanceros",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/divisions/lanceros.png",
    link: "",
    playoffPromotionName: "Lanceros (ASCENSO)",
    playoffPromotion:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/t5/lanceros_ascenso.png",
    playoffPromotionIcon:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/playoffs/icons/piqueros_promotion.png",
    groups: [
      {
        name: "#1",
        link: "/season/5/group/37",
      },
      {
        name: "#2",
        link: "/season/5/group/38",
      },
    ],
    champion: "EagleK",
    promotions: ["EagleK (PlayOff)", "SirEarendil (PlayOff)"],
  },
];

export const eventsT6 = [
  {
    eventId: 1,
    date: "2022-12-27T00:00:00.000Z",
    eventDescs: ["Apertura inscripciones"],
  },
  {
    eventId: 2,
    date: "2023-01-15T00:00:00.000Z",
    eventDescs: ["Cierre inscripciones"],
  },
  {
    eventId: 3,
    date: "2023-01-18T00:00:00.000Z",
    eventDescs: ["Inicio J1"],
  },
  {
    eventId: 4,
    date: "2023-01-25T00:00:00.000Z",
    eventDescs: ["Inicio J2"],
  },
  {
    eventId: 5,
    date: "2023-02-01T00:00:00.000Z",
    eventDescs: ["Fin J1", "Inicio J3"],
  },
  {
    eventId: 6,
    date: "2023-02-08T00:00:00.000Z",
    eventDescs: ["Fin J2", "Inicio J4"],
  },
  {
    eventId: 7,
    date: "2023-02-15T00:00:00.000Z",
    eventDescs: ["Fin J3", "Inicio J5"],
  },
  {
    eventId: 8,
    date: "2023-02-22T00:00:00.000Z",
    eventDescs: ["Fin J4", "Inicio J6 y J7"],
  },
  {
    eventId: 10,
    date: "2023-03-01T00:00:00.000Z",
    eventDescs: ["Fin J5"],
  },
  {
    eventId: 11,
    date: "2023-03-08T00:00:00.000Z",
    eventDescs: ["Fin J6 y J7", "Arranque playoffs"],
  },
  {
    eventId: 12,
    date: "2023-03-22T00:00:00.000Z",
    eventDescs: ["Fin playoffs"],
  },
];

export const draftT6 = {
  draft_PA3: {
    mapLink: "https://aoe2cm.net/preset/apulb",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 6,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://www.aoe2cm.net/preset/lDOuj",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 8,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 9,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 14,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
  draft_BO5: {
    mapLink: "https://aoe2cm.net/preset/USXTi",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://aoe2cm.net/preset/qyxdd",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 8,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 9,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 14,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 15,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 16,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 17,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 18,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 19,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 20,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
};

export const draftT7 = {
  draft_PA3: {
    mapLink: "https://aoe2cm.net/preset/JRGwM",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 6,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://www.aoe2cm.net/preset/lDOuj",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 8,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 9,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 14,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
  draft_BO5: {
    mapLink: "https://aoe2cm.net/preset/LMsRJ",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://aoe2cm.net/preset/qyxdd",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 8,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 9,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 14,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 15,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 16,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 17,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 18,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 19,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 20,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
};

export const draftT8 = {
  draft_PA3: {
    mapLink: "https://aoe2cm.net/preset/dLkpb",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 6,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://www.aoe2cm.net/preset/YjGPg",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 8,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 9,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 14,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
  draft_BO5: {
    mapLink: "https://aoe2cm.net/preset/qkjRv",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://aoe2cm.net/preset/MloRX",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 8,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 9,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 14,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 15,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 16,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 17,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 18,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 19,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 20,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
};

export const draftT9 = {
  draft_PA3: {
    mapLink: "https://aoe2cm.net/preset/BmkzH",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 6,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://aoe2cm.net/preset/oedks",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 8,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 9,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 14,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
  draft_BO5: {
    mapLink: "https://aoe2cm.net/preset/wYMfC",
    mapTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 2,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 3,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 4,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerB",
        action: "PICK",
      },
    ],
    civLink: "https://aoe2cm.net/preset/ZmWRi",
    civTurns: [
      {
        turn: 1,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 2,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 3,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 4,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 5,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 6,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 7,
        player: "playerA",
        action: "BAN",
      },
      {
        turn: 8,
        player: "playerB",
        action: "BAN",
      },
      {
        turn: 9,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 10,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 11,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 12,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 13,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 14,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 15,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 16,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 17,
        player: "playerA",
        action: "PICK",
      },
      {
        turn: 18,
        player: "playerB",
        action: "PICK",
      },
      {
        turn: 19,
        player: "playerA",
        action: "SNIPE",
      },
      {
        turn: 20,
        player: "playerB",
        action: "SNIPE",
      },
    ],
  },
};

export const BO1T8Map = "Canberra";

export const gamesTemplate_PA3 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
];

export const gamesTemplate_BO5 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 4,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
  {
    sequence: 5,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
];

export const gamesTemplate_BO1 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "",
    gameCivB: "",
    map: "",
    gameRec: "",
  },
];

export const civs = [
  {
    id: 15,
    name: "Aztecs",
    uniqueUnits: ["JaguarWarrior"],
    uniqueTechs: ["Atlatl", "GarlandWars"],
  },
  {
    id: 27,
    name: "Berbers",
    uniqueUnits: ["CamelArcher", "Genitour"],
    uniqueTechs: ["Kasbah", "MaghrebiCamels"],
  },
  {
    id: 1,
    name: "Britons",
    uniqueUnits: ["Longbowman"],
    uniqueTechs: ["Yeomen", "Warwolf"],
  },
  {
    id: 32,
    name: "Bulgarians",
    uniqueUnits: ["Konnik"],
    uniqueTechs: ["Stirrups", "Bagains"],
  },
  {
    id: 36,
    name: "Burgundians",
    uniqueUnits: ["Coustillier", "FlemishMilitia"],
    uniqueTechs: ["BurgundianVineyards", "FlemishRevolution"],
  },
  {
    id: 30,
    name: "Burmese",
    uniqueUnits: ["Arambai"],
    uniqueTechs: ["Howdah", "ManipurCavalry"],
  },
  {
    id: 7,
    name: "Byzantines",
    uniqueUnits: ["Cataphract"],
    uniqueTechs: ["GreekFire", "Logistica"],
  },
  {
    id: 13,
    name: "Celts",
    uniqueUnits: ["WoadRaider"],
    uniqueTechs: ["Stronghold", "FurorCeltica"],
  },
  {
    id: 6,
    name: "Chinese",
    uniqueUnits: ["ChuKoNu"],
    uniqueTechs: ["GreatWall", "Rocketry"],
  },
  {
    id: 34,
    name: "Cumans",
    uniqueUnits: ["Kipchak"],
    uniqueTechs: ["SteppeHusbandry", "CumanMercenaries"],
  },
  {
    id: 25,
    name: "Ethiopians",
    uniqueUnits: ["ShotelWarrior"],
    uniqueTechs: ["RoyalHeirs", "TorsionEngines"],
  },
  {
    id: 2,
    name: "Franks",
    uniqueUnits: ["ThrowingAxeman"],
    uniqueTechs: ["Chivalry", "BeardedAxe"],
  },
  {
    id: 3,
    name: "Goths",
    uniqueUnits: ["Huskarl"],
    uniqueTechs: ["Anarchy", "Perfusion"],
  },
  {
    id: 17,
    name: "Huns",
    uniqueUnits: ["Tarkan"],
    uniqueTechs: ["Marauders", "Atheism"],
  },
  {
    id: 21,
    name: "Incas",
    uniqueUnits: ["Kamayuk", "Slinger"],
    uniqueTechs: ["AndeanSling", "FabricShields"],
  },
  /*  {
    id: 20,
    name: "Indians",
    uniqueUnits: ["ElephantArcher", "ImperialCamelRider"],
    uniqueTechs: ["Sultans", "Shatagni"],
  }, 
  {
    id: 99,
    name: "Indians",
    uniqueUnits: ["ElephantArcher", "ImperialCamelRider"],
    uniqueTechs: ["Sultans", "Shatagni"],
  },*/
  {
    id: 19,
    name: "Italians",
    uniqueUnits: ["GenoeseCrossbowman", "Condottiero"],
    uniqueTechs: ["Pavise", "SilkRoad"],
  },
  {
    id: 5,
    name: "Japanese",
    uniqueUnits: ["Samurai"],
    uniqueTechs: ["Yasama", "Kataparuto"],
  },
  {
    id: 28,
    name: "Khmer",
    uniqueUnits: ["BallistaElephant"],
    uniqueTechs: ["TuskSwords", "DoubleCrossbow"],
  },
  {
    id: 18,
    name: "Koreans",
    uniqueUnits: ["WarWagon", "TurtleShip"],
    uniqueTechs: ["Panokseon", "Shinkichon"],
  },
  {
    id: 35,
    name: "Lithuanians",
    uniqueUnits: ["Leitis"],
    uniqueTechs: ["HillForts", "TowerShields"],
  },
  {
    id: 22,
    name: "Magyars",
    uniqueUnits: ["MagyarHuszar"],
    uniqueTechs: ["CorvinianArmy", "RecurveBow"],
  },
  {
    id: 29,
    name: "Malay",
    uniqueUnits: ["KarambitWarrior"],
    uniqueTechs: ["Thalassocracy", "ForcedLevy"],
  },
  {
    id: 26,
    name: "Malians",
    uniqueUnits: ["Gbeto"],
    uniqueTechs: ["Tigui", "Farimba"],
  },
  {
    id: 16,
    name: "Mayans",
    uniqueUnits: ["PlumedArcher"],
    uniqueTechs: ["ObsidianArrows", "ElDorado"],
  },
  {
    id: 12,
    name: "Mongols",
    uniqueUnits: ["Mangudai"],
    uniqueTechs: ["Nomads", "Drill"],
  },
  {
    id: 8,
    name: "Persians",
    uniqueUnits: ["WarElephant"],
    uniqueTechs: ["Kamandaran", "Mahouts"],
  },
  {
    id: 24,
    name: "Portuguese",
    uniqueUnits: ["OrganGun", "Caravel"],
    uniqueTechs: ["Carrack", "Arquebus"],
  },
  {
    id: 9,
    name: "Saracens",
    uniqueUnits: ["Mameluke"],
    uniqueTechs: ["Madrasah", "Zealotry"],
  },
  {
    id: 37,
    name: "Sicilians",
    uniqueUnits: ["Serjeant"],
    uniqueTechs: ["FirstCrusade", "Scutage"],
  },
  {
    id: 23,
    name: "Slavs",
    uniqueUnits: ["Boyar"],
    uniqueTechs: ["Orthodoxy", "Druzhina"],
  },
  {
    id: 14,
    name: "Spanish",
    uniqueUnits: ["Conquistador", "Missionary"],
    uniqueTechs: ["Inquisition", "Supremacy"],
  },
  {
    id: 33,
    name: "Tatars",
    uniqueUnits: ["Keshik", "FlamingCamel"],
    uniqueTechs: ["SilkArmor", "TimuridSiegecraft"],
  },
  {
    id: 4,
    name: "Teutons",
    uniqueUnits: ["TeutonicKnight"],
    uniqueTechs: ["Ironclad", "Crenellations"],
  },
  {
    id: 10,
    name: "Turks",
    uniqueUnits: ["Janissary"],
    uniqueTechs: ["Sipahi", "Artillery"],
  },
  {
    id: 31,
    name: "Vietnamese",
    uniqueUnits: ["RattanArcher"],
    uniqueTechs: ["Chatras", "PaperMoney"],
  },
  {
    id: 11,
    name: "Vikings",
    uniqueUnits: ["Berserk", "Longboat"],
    uniqueTechs: ["Chieftains", "Berserkergang"],
  },
  {
    id: 38,
    name: "Poles",
    uniqueUnits: ["Obuch", "Winged Hussar"],
    uniqueTechs: ["Szlachta Privileges", "Lechitic Legacy"],
  },
  {
    id: 39,
    name: "Bohemians",
    uniqueUnits: ["Hussite Wagon", "Houfnice"],
    uniqueTechs: ["Wagenburg Tactics", "Hussite Reforms"],
  },
  {
    id: 40,
    name: "Dravidians",
    uniqueUnits: ["Urumi Swordsman", "Thirisadai"],
    uniqueTechs: ["Medical Corps", "Wootz Steel"],
  },
  {
    id: 41,
    name: "Bengalis",
    uniqueUnits: ["Ratha"],
    uniqueTechs: ["Paiks", "Mahayana"],
  },
  {
    id: 42,
    name: "Gurjaras",
    uniqueUnits: ["Chakram Thrower", "Shrivamsha Rider"],
    uniqueTechs: ["Kshatriyas", "Frontier Guards"],
  },
  {
    id: 43,
    name: "Hindustanis",
    uniqueUnits: ["Grand Trunk Road", "Shatagni"],
    uniqueTechs: ["Ghulam", "Imperial Camel Rider"],
  },
  {
    id: 100,
    name: "Georgians",
  },
  {
    id: 101,
    name: "Armenians",
  },
  { id: 12, name: "Romans" },
  {
    id: 102,
    name: "Wei",
  },
  {
    id: 103,
    name: "Wu",
  },
  {
    id: 104,
    name: "Shu",
  },
  {
    id: 105,
    name: "Jurchens",
  },
  {
    id: 106,
    name: "Khitans",
  },
  {
    id: 107,
    name: "Tupis",
  },
  {
    id: 108,
    name: "Muiscas",
  },
  {
    id: 109,
    name: "Mapuches",
  },
];

export const eventsT7 = [
  {
    eventId: 1,
    date: "2023-05-03T00:00:00.000Z",
    eventDescs: ["Apertura inscripciones"],
  },
  {
    eventId: 2,
    date: "2023-05-27T00:00:00.000Z",
    eventDescs: ["Cierre inscripciones"],
  },
  {
    eventId: 3,
    date: "2023-05-30T00:00:00.000Z",
    eventDescs: ["Inicio J1"],
  },
  {
    eventId: 4,
    date: "2023-06-06T00:00:00.000Z",
    eventDescs: ["Inicio J2"],
  },
  {
    eventId: 5,
    date: "2023-06-13T00:00:00.000Z",
    eventDescs: ["Fin J1", "Inicio J3"],
  },
  {
    eventId: 6,
    date: "2023-06-20T00:00:00.000Z",
    eventDescs: ["Fin J2", "Inicio J4"],
  },
  {
    eventId: 7,
    date: "2023-06-27T00:00:00.000Z",
    eventDescs: ["Fin J3", "Inicio J5, J6 y J7"],
  },
  {
    eventId: 8,
    date: "2023-07-04T00:00:00.000Z",
    eventDescs: ["Fin J4"],
  },
  {
    eventId: 10,
    date: "2023-07-11T00:00:00.000Z",
    eventDescs: ["-"],
  },
  {
    eventId: 11,
    date: "2023-07-18T00:00:00.000Z",
    eventDescs: ["Fin J5, J6 y J7", "Arranque playoffs"],
  },
  {
    eventId: 12,
    date: "2023-08-01T00:00:00.000Z",
    eventDescs: ["Fin playoffs"],
  },
];

export const eventsT8 = [
  {
    eventId: 1,
    date: "2024-02-12T00:00:00.000Z",
    eventDescs: ["Apertura inscripciones"],
  },
  {
    eventId: 2,
    date: "2024-03-01T00:00:00.000Z",
    eventDescs: ["Cierre inscripciones"],
  },
  {
    eventId: 3,
    date: "2024-03-05T00:00:00.000Z",
    eventDescs: ["Inicio J1"],
  },
  {
    eventId: 4,
    date: "2024-03-12T00:00:00.000Z",
    eventDescs: ["Inicio J2"],
  },
  {
    eventId: 5,
    date: "2024-03-19T00:00:00.000Z",
    eventDescs: ["Fin J1", "Inicio J3"],
  },
  {
    eventId: 6,
    date: "2024-03-26T00:00:00.000Z",
    eventDescs: ["Fin J2", "Inicio J4"],
  },
  {
    eventId: 7,
    date: "2024-04-02T00:00:00.000Z",
    eventDescs: ["Fin J3", "Inicio J5, J6 y J7"],
  },
  {
    eventId: 8,
    date: "2024-04-09T00:00:00.000Z",
    eventDescs: ["Fin J4"],
  },
  {
    eventId: 10,
    date: "2024-04-16T00:00:00.000Z",
    eventDescs: ["-"],
  },
  {
    eventId: 11,
    date: "2024-04-23T00:00:00.000Z",
    eventDescs: ["Fin J5, J6 y J7", "Arranque playoffs"],
  },
  {
    eventId: 12,
    date: "2024-05-07T00:00:00.000Z",
    eventDescs: ["Fin playoffs"],
  },
];

export const mapsT8 = [
  {
    id: 1,
    name: "Arabia",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_arabia.png",
  },
  {
    id: 2,
    name: "Migración",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_migration.png",
  },
  {
    id: 3,
    name: "Winged",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Winged.png",
  },
  {
    id: 4,
    name: "Canberra",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Canberra.png",
  },
  {
    id: 5,
    name: "Arena",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Arena.png",
  },
  {
    id: 6,
    name: "Hippopotamus",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Hippopotamus.png",
  },
  {
    id: 7,
    name: "Carlo Africano",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Carlo-Africano.png",
  },
];

export const mapsT9 = [
  {
    id: 1,
    name: "Arabia",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_arabia.png",
  },
  {
    id: 9,
    name: "Golden Lakes",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_golden_lakes.png",
  },
  {
    id: 10,
    name: "Border Dispute",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_border_dispute.png",
  },
  {
    id: 11,
    name: "Andalucia",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_andalucia.png",
  },
  {
    id: 12,
    name: "Mired",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_mired.png",
  },
  {
    id: 13,
    name: "Rocky Forest",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_rocky_forest.png",
  },
  {
    id: 14,
    name: "Islands",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Islands.png",
  },
];

export const maps = [
  {
    id: 1,
    name: "Arabia",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_arabia.png",
  },
  {
    id: 2,
    name: "Migración",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_migration.png",
  },
  {
    id: 3,
    name: "Winged",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Winged.png",
  },
  {
    id: 4,
    name: "Canberra",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Canberra.png",
  },
  {
    id: 5,
    name: "Arena",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Arena.png",
  },
  {
    id: 6,
    name: "Hippopotamus",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Hippopotamus.png",
  },
  {
    id: 7,
    name: "Carlo Africano",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Carlo-Africano.png",
  },
  {
    id: 9,
    name: "Golden Lakes",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_golden_lakes.png",
  },
  {
    id: 10,
    name: "Border Dispute",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_border_dispute.png",
  },
  {
    id: 11,
    name: "Andalucia",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_andalucia.png",
  },
  {
    id: 12,
    name: "Mired",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_mired.png",
  },
  {
    id: 13,
    name: "Rocky Forest",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_rocky_forest.png",
  },
  {
    id: 14,
    name: "Islands",
    image:
      "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/LEA_Islands.png",
  },
];

export const getMapImage = (mapName, maps) => {
  const map = maps.find((map) => map.name === mapName);
  return map ? map.image : null;
};

export const generic_map =
  "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/cm_generic.png";
export const generic_civ =
  "https://alexocampos.github.io/liga-espanhola-aoe2-static/civs/generic_civ.png";
//export const players_detailed_url = "http://127.0.0.1:5000/players-detailed";
export const players_detailed_url =
  "https://alexocampos.github.io/liga-espanhola-aoe2-static/api/season/3/players/players-detailed.json";

//export const backend_server = "http://127.0.0.1:5000";
export const backend_server = "https://liga-espanola-aoe2.herokuapp.com";
export const registrations_url = `${backend_server}/registrations`;
export const divisions_url = `${backend_server}/divisions/`;

export const next_matches_url = `${backend_server}/matches/next`;

export const GROUP_PHASE_LEAGUE = 0;
export const GROUP_PHASE_PLAYOFF = 1;

export const season_id = 7;
export const current_season = 7;

export const register_url = `${backend_server}/leabe/1/auth/register/${season_id}`;
export const login_url = `${backend_server}/leabe/1/auth/login`;
export const update_user = `${backend_server}/leabe/1/user`;
export const get_user_url = `${backend_server}/leabe/1/user`;
export const list_of_players = `${backend_server}/leabe/1/season/${season_id}/players`;
export const list_of_players_admin = `${backend_server}/leabe/1/season/${season_id}/players/admin`;
export const update_player_url_admin = `${backend_server}/leabe/1/season/${season_id}/players/admin`;
export const update_player_url = `${backend_server}/leabe/1/user`;
export const list_of_divisions_url = `${backend_server}/leabe/1/season/${season_id}/divisions`;
export const group_detail_url = `${backend_server}/leabe/1/season/${season_id}/groups/:groupId/classification`;
export const group_playoffs_url = `${backend_server}/leabe/1/season/${season_id}/groups/:groupId/matches`;
export const set_players_in_group_url = `${backend_server}/leabe/1/season/${season_id}/groups/:groupId/players`;
export const match_detail_url = `${backend_server}/leabe/1/season/${season_id}/matches/:matchId`;
export const match_creation_url = `${backend_server}/leabe/1/season/${season_id}/matches/admin`;
export const match_list = `${backend_server}/leabe/1/season/${season_id}/matches`;
export const register_season_url = `${backend_server}/leabe/1/user/season/${season_id}/register`;

// API with seasonId parameter
export const api_register_season = (seasonId) =>
  `${backend_server}/leabe/1/user/season/${seasonId}/register`;
export const api_list_of_players = (seasonId) =>
  `${backend_server}/leabe/1/season/${seasonId}/players`;

// Constants
export const discordUrl = "https://discord.gg/mnJvxJBz2w";
export const twitterUrl = "https://twitter.com/Aoe2ESP";

export const AW_PLAYER_A = 0;
export const AW_PLAYER_B = 1;
export const AW_BOTH_PLAYERS = 2;
export const AW_REMOVE = -1;

export const MATCH_PHASE_TYPE_REGULAR_LEAGUE = "REGULAR_LEAGUE";
export const MATCH_PHASE_TYPE_PLAYOFF = "PLAYOFF";
export const MATCH_PHASE_TYPE_PLAYIN = "PLAYIN";
export const MATCH_FORMAT_PA3 = "PA3";
export const MATCH_FORMAT_BO5 = "BO5";
export const MATCH_FORMAT_BO1 = "BO1";

export const MATCH_STATUS_HIDDEN = "HIDDEN";
export const MATCH_STATUS_PENDING_DATE = "PENDING_DATE";
export const MATCH_STATUS_NOT_STARTED = "NOT_STARTED";
export const MATCH_STATUS_FINISHED = "FINISHED";
export const MATCH_STATUS_REVIEWED = "REVIEWED";

export const getMatchStatusName = (status) => {
  if (status === MATCH_STATUS_FINISHED) {
    return "Finalizado";
  }
  if (status === MATCH_STATUS_PENDING_DATE) {
    return "Pendiente fecha";
  }
  if (status === MATCH_STATUS_HIDDEN) {
    return "No publicado";
  }
  if (status === MATCH_STATUS_REVIEWED) {
    return "Revisada admin";
  }
  if (status === MATCH_STATUS_NOT_STARTED) {
    return "Pendiente jugar";
  }
};

export const randomAvatar = () => {
  return `https://alexocampos.github.io/liga-espanhola-aoe2-static/avatars/avatar_${Math.floor(Math.random() * 9) + 1
    }.webp`;
};

// Player Status
export const NOT_REGISTERED = "NOT_REGISTERED";
export const NEW_USER = "NEW_USER";
export const PENDING = "PENDING";
export const REV_IN_PROGRESS = "REV_IN_PROGRESS";
export const APPROBED = "APPROBED";
export const REJECTED = "REJECTED";
export const BANNED = "BANNED";

// 2024 =======================================================================
export const static_server =
  "https://alexocampos.github.io/liga-espanhola-aoe2-static";

export const login_url_discord =
  "https://discord.com/api/oauth2/authorize?client_id=1042112312074588230&response_type=code&scope=identify%20email%20connections%20guilds%20guilds.join";
export const redirect_login_url = `${frontend_server}`;

export const current_tournament = "ac2392e3-05a2-4ecf-b516-93a1da96ecec";
// API para obtener el torneo actual

export const current_background_video =
  "https://alexocampos.github.io/liga-espanhola-aoe2-static/videos/home-video-t6.mp4";

export const register_ok_redirect_uri = () =>
  `${frontend_server}/tournament/register-ok`;

export const PLAYERDESCANSA = {
  playerId: "0de21350-c4db-48fc-91b6-6e880057aef7",
  username: "DESCANSA",
  oldUserId: "",
  email: "DESCANSA@descansa.com",
  clanId: null,
  aoe2Country: "ES",
  aoe2Name: "DESCANSA",
  aoe2ProfileId: "",
  steamId: "",
  discordAvatarURL: "",
  discordUsername: "DESCANSA",
  discordId: "DESCANSA",
  isAdmin: false,
  tournamentHistory: [
    {
      tournamentId: "d896f010-9f12-412d-8c52-6caea6cb81fe",
      status: "APPROBED",
      comments: "",
      eloAvg: 0.0,
      eloRegistry: 0.0,
      registerConditions: [],
    },
  ],
  timeCreated: "04-03-2024 08:08:27",
  timeUpdated: "04-03-2024 08:08:27",
};

// Players APIs
export const api_v3_list_of_players_admin = (tournamentId, filterNoGroup) =>
  `${backend_server_v3}/api/v1/player/admin${tournamentId
    ? `?tournamentId=${tournamentId}${filterNoGroup ? "&noGroup=True" : ""}`
    : ""
  }`;
export const api_v3_list_of_players_by_playerIds = (playerIds) =>
  `${backend_server_v3}/api/v1/player/?playerIds=${playerIds}`;
export const api_v3_list_of_players = () =>
  `${backend_server_v3}/api/v1/player/`;
export const api_v3_list_of_players_by_tournamentId = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/players`;
export const api_v3_update_player_admin = (playerId) =>
  `${backend_server_v3}/api/v1/player/${playerId}`;
export const api_v3_get_moderators = () =>
  `${backend_server_v3}/api/v1/player/admin?isModerator=true`;
export const api_v3_update_player_roles = (playerId) =>
  `${backend_server_v3}/api/v1/player/${playerId}/set-admin`;
export const api_v3_update_player_tournament_status_admin = (
  playerId,
  tournamentId
) =>
  `${backend_server_v3}/api/v1/player/${playerId}/tournament/${tournamentId}/status`;
export const api_v3_get_aoe2_player_info = (playerId) =>
  `${backend_server_v3}/api/v1/player/${playerId}/aoe2info`;
export const api_v3_leaderboard = () =>
  `${backend_server_v3}/api/v1/player/leaderboard`;
export const api_v3_sync_history = (limit = 50) =>
  `${backend_server_v3}/api/v1/jobs/sync-history?limit=${limit}`;
export const api_v3_sync_kill = (recordId) =>
  `${backend_server_v3}/api/v1/jobs/sync-history/${recordId}/kill`;
export const api_v3_sync_force_cancel = (recordId) =>
  `${backend_server_v3}/api/v1/jobs/sync-history/${recordId}/force-cancel`;
export const api_v3_jobs_unlock = () =>
  `${backend_server_v3}/api/v1/jobs/unlock`;
export const api_v3_sync_delete_all = () =>
  `${backend_server_v3}/api/v1/jobs/sync-history`;
export const api_v3_merge_players = () =>
  `${backend_server_v3}/api/v1/admin/merge-players`;
export const api_v3_player_stats = (playerId) =>
  `${backend_server_v3}/api/v1/player/${playerId}/stats`;
// User APIs
export const api_v3_user_detail = () => `${backend_server_v3}/api/v1/users/me`;
export const api_v3_user_detail_update = () =>
  `${backend_server_v3}/api/v1/users/update`;
export const api_v3_login_register = () =>
  `${backend_server_v3}/api/v1/auth/login`;
export const api_v3_register = (code, redirectUri) =>
  `${backend_server_v3}/api/v1/users/register?code=${code}&redirectUri=${redirectUri}`;
export const api_v3_user_register_tournament = (tournamentId) =>
  `${backend_server_v3}/api/v1/users/tournament/${tournamentId}/sign-up`;
export const api_v3_user_aoe2_info = (playerId) =>
  `${backend_server_v3}/api/v1/player/${playerId}/aoe2info`;
export const api_v3_player_register_streamer = (tournamentId) =>
  `${backend_server_v3}/api/v1/users/tournament/${tournamentId}/streamer`;

// Clan APIs
export const api_v3_list_of_clans = () => `${backend_server_v3}/api/v1/clans/`;

// Tournament APIs
export const api_v3_list_of_tournaments = () =>
  `${backend_server_v3}/api/v1/tournament/`;
export const api_v3_get_tournament_by_id = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}`;

export const api_v3_get_groups_draft = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/groups-draft`;

export const api_v3_save_groups_draft = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/groups-draft`;

export const api_v1_get_hall_of_fame = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/hall-of-fame`;

export const api_v1_save_hall_of_fame = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/hall-of-fame`;

export const api_v3_update_tournament_by_id = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}`;

export const api_v3_create_tournament_by_id = () =>
  `${backend_server_v3}/api/v1/tournament`;

export const api_v3_delete_tournament_by_id = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}`;

// Division APIs
export const api_v3_create_division = () =>
  `${backend_server_v3}/api/v1/divisions`;
export const api_v3_get_division_by_id = (divisionId) =>
  `${backend_server_v3}/api/v1/divisions/${divisionId}`;
export const api_v3_update_division_by_id = (divisionId) =>
  `${backend_server_v3}/api/v1/divisions/${divisionId}`;

export const api_v3_get_classification = (divisionId, groupId) =>
  `${backend_server_v3}/api/v1/divisions/${divisionId}/group/${groupId}/classification`;
export const api_v3_update_players_to_group = (divisionId, groupId) =>
  `${backend_server_v3}/api/v1/divisions/${divisionId}/group/${groupId}/players`;

// Matches APIs
export const api_v3_get_match_by_id = (matchId) =>
  `${backend_server_v3}/api/v1/matches/${matchId}`;
export const api_v3_get_matches_by_player_and_tournament = (
  playerId,
  tournamentId,
  excludePlayoffs
) =>
  `${backend_server_v3}/api/v1/matches/?tournamentId=${tournamentId}&playerId=${playerId}${excludePlayoffs ? "&excludedLeagueDays=0" : ""
  }`;
export const api_v3_get_matches_by_tournament_division_group = (
  tournamentId,
  divisionId,
  groupId,
  excludePlayoffs
) =>
  `${backend_server_v3}/api/v1/matches/?tournamentId=${tournamentId}&divisionId=${divisionId}&groupId=${groupId}${excludePlayoffs ? "&excludedLeagueDays=0" : ""
  }`;
export const api_v3_update_match_by_players = (matchId) =>
  `${backend_server_v3}/api/v1/matches/${matchId}`;
export const api_v3_update_match_by_admin = (matchId) =>
  `${backend_server_v3}/api/v1/matches/${matchId}/admin`;
export const api_v3_get_matches_by_tournament_with_date = (tournamentId) =>
  `${backend_server_v3}/api/v1/matches/?tournamentId=${tournamentId}&statuses=${MATCH_STATUS_NOT_STARTED},${MATCH_STATUS_FINISHED},${MATCH_STATUS_REVIEWED}`;
export const api_v3_get_playoff_matches_by_tournament = (tournamentId) =>
  `${backend_server_v3}/api/v1/matches/?tournamentId=${tournamentId}&phases=PLAYOFF,PLAYIN`;
export const api_v3_delete_matches_by_group = (groupId) =>
  `${backend_server_v3}/api/v1/matches/by_group/${groupId}`;
export const api_v3_generate_matches_round_robin = (
  tournamentId,
  divisionId,
  groupId
) =>
  `${backend_server_v3}/api/v1/matches/tournament/${tournamentId}/division/${divisionId}/group/${groupId}/round-robin`;

export const api_v3_create_match = () => `${backend_server_v3}/api/v1/matches/`;

export const api_v3_publish_matches_by_league_day = (
  tournamentId,
  divisionId,
  groupId,
  leagueDay
) =>
  `${backend_server_v3}/api/v1/matches/tournament/${tournamentId}/division/${divisionId}/group/${groupId}/leagueDay/${leagueDay}/publish`;

export const api_v3_get_matches_by_tournament_by_states = (
  tournamentId,
  statuses
) =>
  `${backend_server_v3}/api/v1/matches/?tournamentId=${tournamentId}&statuses=${statuses}&excludedLeagueDays=0`;

export const api_v3_get_streaming_by_match = (matchId) =>
  `${backend_server_v3}/api/v1/matches/${matchId}/streaming`;

export const api_v3_update_streaming_by_match = (matchStreamingId) =>
  `${backend_server_v3}/api/v1/matches/streaming/${matchStreamingId}`;

export const api_v3_create_streaming_by_match = () =>
  `${backend_server_v3}/api/v1/matches/streaming`;

export const api_v3_delete_streaming_by_match = (matchStreamingId) =>
  `${backend_server_v3}/api/v1/matches/streaming/${matchStreamingId}`;

export const api_v3_get_streamings_by_tournament = (tournamentId) =>
  `${backend_server_v3}/api/v1/matches/streamings/?tournamentId=${tournamentId}`;

export const api_v3_get_tournament_details = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/details`;

export const api_v3_get_tournament_details_admin = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/details/admin`;

export const api_v3_update_tournament_details = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/details`;

export const api_v1_get_current_tournament = () =>
  `${backend_server_v3}/api/v1/tournament/current`;

export const api_v1_update_current_tournament = () =>
  `${backend_server_v3}/api/v1/tournament/current`;

export const api_v3_generate_playoffs = (divisionId) =>
  `${backend_server_v3}/api/v1/division/${divisionId}/generate-playoffs`;

export const api_v3_get_classification_strategies = () =>
  `${backend_server_v3}/api/v1/tournament/classification-strategies`;

export const api_v3_refresh_all_classifications = (tournamentId) =>
  `${backend_server_v3}/api/v1/tournament/${tournamentId}/refresh-classifications`;
